// extracted by mini-css-extract-plugin
export var statItem = "_gt-1";
export var statsRow = "_gt-0";